export default {
  en: {
    'sagas.handle-import-game-changer.invalid':
      'The uploaded file is invalid. It must be a plain text file.',
  },
};
